import request from "./request";
import apis from "./apis";

const {
  roleInfo,
} = apis.role;

const role = {
  getRoleInfo: () => {
    return request.get(roleInfo);
  },
  createRoleInfo: (data: Object) => {
    return request.post(roleInfo, data);
  },
  updateRoleInfo: (data: Object) => {
    return request.put(roleInfo, data);
  },
  deleteRoleInfo: (id: Object) => {
    return request.delete(roleInfo, id);
  },
};

export default role;